export class ParameterNotFoundError extends Error {
  override name = 'ParameterNotFoundError';

  constructor(parameterName: string) {
    super(`Parameter not found: ${parameterName}`);
  }
}
